import React, { useState, useRef } from "react";
import FilterDropDown from "../DropDown/DropDown";
import FilterIcon from "../../../asset/jobs/filter.svg";
import filter from "../../../asset/jobs/filter.svg";
import { CSVLink } from "react-csv";
import "./FilterJobs.scss";
import SearchIcon from "@mui/icons-material/Search";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { DateRange } from "react-date-range";

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import { format } from "date-fns";
import CalendarRange from "../../PopUp/CalendarRange/CalendarRange";

const FilterJobs = ({
  filterDate,
  setFilterDate,
  tableData,
  setFilterTable,
  globalInputSearch,
  SetGlobalInputSearch,
  departmentList,
  departmentValue,
  setDepartmentValue,
  professionsValue,
  setProfessionValue,
  fetchAllData,
  title,
  showDownloadIcon,
  professional,
  downloadIcon,
  dowload,
  professionalList,
  keyword,
  setKeyword,
  filterByProfession,
  setFilterByProfession,
  filterByDepartment,
  setFilterByDepartment,
  filterByStartDate,
  setFilterByStartDate,
  filterByEndDate,
  setFilterByEndDate,
  filterByBranch,
  setFilterByBranch,
  filterByStatus,
  setFilterByStatus,
  hospitalBranchList,
  hospitalBranch,
  handleBranchFilterChange,
  hospitalBranchOptions,
  setHospitalBranch,
  setHospitalBranchId,
  csvData,
  exportPDF,
  downloadTable,
  handleCsvDownload
}) => {
  let [openRangeCalendar, setOpenRangeCalendar] = useState(false);
  let [downloadOption, setDownloadOption] = useState("");
  const searchInputRef = useRef(null);
  const [statusList] = useState([
    { value: "", label: "All Status" },
    { value: "PENDING_APPROVAL", label: "Pending " },
    { value: "APPROVED", label: "Approved" },
    { value: "DISPUTED", label: "Disputed" },
    // { value: "RESOLVED", label: "Approved" },
  ]);

  function resetAll() {
    setDepartmentValue("");
    setProfessionValue("");
    setFilterByProfession("");
    setFilterByDepartment("");
    setFilterByBranch("");
    setHospitalBranch("");
    setHospitalBranchId("");
    setKeyword("");
    setFilterByStartDate("");
    setFilterByEndDate("");
    SetGlobalInputSearch("");
    setFilterTable(tableData);
    fetchAllData();
    // setFilterDate([{ key: "selection" }]);
  }

  function formatDate(date) {
    // return date instanceof Date ? date.toLocaleDateString("en-GB"): date;
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  const handleDownloadChange = (e) => {
    // console.log("48-->", totalData)
    setDownloadOption(e?.target?.value);
    // if (e.target.value === "PDF") {
    //   exportPDF(totalData);
    // } else if (e.target.value === "CSV") {
    //   // const csvData = totalData;
    //   csvData(totalData)
    // }
  };

  // console.log("start date", filterByStartDate)
  // console.log("hospitalBranchList", hospitalBranchList)
  return (
    <div
      style={{
        // display: "flex",
        // justifyContent: "space-between",
        // alignItems: "center",
        // backgroundColor: "white",
      }}
    >
      <div className="sl-filter">
      

        <FormControl sx={{}}>
          <TextField
            select
           sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

            size="small"
            label={!filterByDepartment ? "Departments" : ""}
            value={filterByDepartment || ""}
            InputLabelProps={{ shrink: false }}
            onChange={(e) => setFilterByDepartment(e.target.value)}
            displayEmpty
            labelId="demo-simple-select-autowidth-label"
            inputProps={{ "aria-label": "Without label" }}
          >
            {departmentList?.map((data) => (
              <MenuItem value={data}>{data}</MenuItem>
            ))}
          </TextField>
        </FormControl>

        <FormControl sx={{}}>
          <TextField
            select
                       sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

            size="small"
            label={!filterByProfession ? "Profession" : ""}
            value={filterByProfession || ""}
            InputLabelProps={{ shrink: false }}
            onChange={(e) => setFilterByProfession(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            {professionalList?.map((data) => (
              <MenuItem value={data}>{data}</MenuItem>
            ))}
          </TextField>
        </FormControl>

        <FormControl sx={{}}>
          <TextField
            select
                                        sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

            size="small"
            // value={filterByBranch}
            
            label={!hospitalBranch ? "Branch" : ""}
            value={hospitalBranch || ""}
            InputLabelProps={{ shrink: false }}
            // onChange={(e) => setFilterByBranch(e.target.value)}
            onChange={handleBranchFilterChange}
            displayEmpty
            labelId="demo-simple-select-autowidth-label"
            inputProps={{ "aria-label": "Without label" }}
          >
            {/* {hospitalBranchList?.map((data) => (
            <MenuItem value={data}>{data}</MenuItem>
          ))} */}

            {hospitalBranchOptions?.map((data) => (
              <MenuItem value={data.value}>{data.value}</MenuItem>
            ))}
          </TextField>
        </FormControl>

        {/* Status Dropdown */}
        {/* <FormControl className="filter-dropdown" size="small">
          <InputLabel id="status-label">Status</InputLabel>
          <Select
            labelId="status-label"
            id="status-select"
            value={filterByStatus || ""}
            label="Status"
            onChange={(e) => {
              setFilterByStatus(e.target.value);
            }}
            className="dropdown"
          >
            {statusList.map((status) => (
              <MenuItem key={status.value} value={status.value}>
                {status.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        {showDownloadIcon ? (
          <FormControl sx={{}}>
            <TextField
              select
                                          sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

              size="small"
              // value={filterByBranch}
                value={filterByStatus || ""}
              label={!filterByStatus ? "Approval Status" : ""}
              InputLabelProps={{ shrink: false }}
              // onChange={(e) => setFilterByBranch(e.target.value)}
              onChange={(e) => {
                setFilterByStatus(e.target.value);
              }}
              displayEmpty
              labelId="demo-simple-select-autowidth-label"
              inputProps={{ "aria-label": "Without label" }}
            >
              {/* {hospitalBranchList?.map((data) => (
            <MenuItem value={data}>{data}</MenuItem>
          ))} */}

              {statusList.map((status) => (
                <MenuItem key={status.value} value={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        ) : null}
        {showDownloadIcon ? (
          <TextField
            select
            size="small"
                                 sx={{ width: "170px", "& .MuiOutlinedInput-root": { borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", "& fieldset": { border: "none" } } }}

            //  className="download-dropdown"
            // sx={{ width: "120px", marginRight: "1rem" }}
            value={downloadOption}
            onChange={() => {
              handleDownloadChange();
              // trackReOpenJobDwnld()
            }}
             label={!downloadOption ? "Download" : ""}  // Conditional label
InputLabelProps={{ shrink: false }}     // Prevents shrinking
            displayEmpty
            labelId="demo-simple-select-autowidth-label"
            inputProps={{ "aria-label": "Without label" }}
            placeholder="Select"
          >
            <MenuItem disabled value="">
              Download
            </MenuItem>

            <MenuItem
              value="PDF"
              disabled={!downloadTable || downloadTable.length === 0}
            >
              <span
                onClick={() => {
                  exportPDF();
                  // trackReOpenJobDwnld()
                }}
              >
                Download as PDF
              </span>
            </MenuItem>
            <MenuItem value="CSV"
             disabled={!csvData || csvData?.length <= 1}>
              {" "}
              {/* <CSVLink data={csvData}>Download as CSV</CSVLink> */}
              <CSVLink data={csvData} onClick={handleCsvDownload} filename={`${title} Report.csv`}>
                Download as CSV
              </CSVLink>
            </MenuItem>
          </TextField>
        ) : null}
              <label className={`global-search-container ${keyword ? 'has-text' : ''}`}>
        <div onClick={() => searchInputRef.current?.focus()}>
            <SearchIcon />
          </div>
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            // style={{ width: "50px" }}
          />
        </label>
        <div className={`date-range-wrapper ${filterByStartDate && filterByEndDate ? 'has-dates' : ''}`}>
        
          <label className="date-range-container">

            {/* style={{border: "none", "& .MuiOutlinedInput-root": { "& fieldset": { border: "none" } } }}> */}
           <div onClick={() => setOpenRangeCalendar(!openRangeCalendar)}>
              <EventNoteIcon />
            </div>
            <input
              type="text"
              placeholder="Date Range"
              value={
                filterByStartDate && filterByEndDate
                  ? `${formatDate(filterByStartDate)} - ${formatDate(
                      filterByEndDate
                    )}`
                  : null
              }
              readOnly
            />
            
           
          </label>
        </div>
      
        <div className="filter-button-a" onClick={resetAll}
            style={{ borderRadius: "10px", border: "1px solid lightgray", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", backgroundColor: "white" }}>

             {/* style={{  backgroundColor: "white", borderRadius:"5px", border: "none" }}> */}
            <RotateLeftIcon />
          </div>

        {/* <label 
          className="date-range-container" 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: 0, 
            margin: 0 
          }}
        >
          <input
            type="text"
            placeholder="Search"
            value={
              filterByStartDate && filterByEndDate
                ? `${formatDate(filterByStartDate)} - ${formatDate(
                    filterByEndDate
                  )}`
                : "Date Range"
            }
            style={{ 
              width: "120px",
              padding: "4px 8px",
              margin: 0,
              border: "none",
              outline: "none",
              background: "transparent"
            }}
            readOnly
          />

          <div 
            onClick={() => setOpenRangeCalendar(!openRangeCalendar)}
            style={{ 
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              padding: '0 4px'
            }}
          >
            <EventNoteIcon />
          </div>
        </label> */}
      </div>

      <Modal
        open={openRangeCalendar}
        onClose={() => setOpenRangeCalendar(!openRangeCalendar)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <CalendarRange
          setOpenRangeCalendar={setOpenRangeCalendar}
          // setFilterDate={setFilterDate}
          // filterDate={filterDate}
          filterByStartDate={filterByStartDate}
          setFilterByStartDate={setFilterByStartDate}
          filterByEndDate={filterByEndDate}
          setFilterByEndDate={setFilterByEndDate}
        />
      </Modal>
    </div>
  );
};

export default FilterJobs;
